import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./video.templates";

export default {
    title: "Website/Partial Templates/Nimbus/Video",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {},
};

export const Default = {};

export const Multiple = {
    args: {
        count: 3,
    },
};
